export type TFieldsLayoutEntry =
  | { type: 'FIELD'; id: string }
  | { type: 'GROUP'; items: { id: string }[] };

function toFieldIds(entry: TFieldsLayoutEntry): string[] {
  switch (entry.type) {
    case 'FIELD':
      return [entry.id];
    case 'GROUP':
      return entry.items.map((item) => item.id);
    default: {
      const unhandled: never = entry;

      return unhandled;
    }
  }
}

export function flattenFieldsLayout(fieldsLayout: TFieldsLayoutEntry[]): string[] {
  return fieldsLayout.flatMap(toFieldIds);
}
